module.exports = __webpack_public_path__ + "img/Transit_acc_2.1ea8d857.jpg";